import React from "react";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";

export default class Mask extends React.Component {
	static propTypes = {
		dataTest: PropTypes.string,
		className: PropTypes.string.isRequired,
		value: PropTypes.string,
		changeCallback: PropTypes.func,
		onMount: PropTypes.func,
		onFocus: PropTypes.func,
	};

	static defaultProps = {
		dataTest: "",
		className: "",
		changeCallback: () => {},
		onMount: () => {},
		onFocus: () => {},
	};

	componentDidMount() {
		this.props.onMount();
	}

	changeHandler(e) {
		let value = e.target.value;
		this.props.changeCallback(value);
	}

	formatChars = {
		9: "[0-9]",
		8: "[1-9]",
	};

	render() {
		let options = {
			mask: `899999`,
			formatChars: this.formatChars,
			maskChar: null,
			className: this.props.className,
			onChange: (e) => {
				this.changeHandler(e);
			},
			onFocus: this.props.onFocus,
			datatest: this.props.datatest,
			autoComplete: "on",
			id: this.props.id,
		};
		if (typeof this.props.value === "string") {
			options.value = this.props.value;
		}
		return <InputMask {...options} />;
	}
}
